import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/invoices/{id}/payment-plans']['PUT'];
type Input = ThisApi['body'] & ThisApi['params'];

const updatePaymentPlan = async ({ id, ...body }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(`/invoices/${id}/payment-plans`, body);
  return response.data;
};

export default updatePaymentPlan;
